import CouchdbClass from './CouchdbClass'
import hasher from 'password-hash-and-salt'
import store from './../vuex/store'

const Couchdb = new CouchdbClass({ connection: 'config', collection: 'users' })

export default {
  checkCredentials ({ login, password }) {
    return new Promise((resolve, reject) => {
      Couchdb.where('login', login).first()
        .then(user => {
          if (user === null) {
            resolve(false)
          } else {
            hasher(password).verifyAgainst(user.password, (error, verified) => {
              if (error) throw new Error('Something went wrong!')
              if (!verified) {
                resolve(false)
              } else {
                delete user.password
                resolve(user)
              }
            })
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  logout () {
    localStorage.setItem('isLoggedIn', false)
    store.dispatch('unsetUser', {})
  },
  hash (password) {
    return new Promise((resolve, reject) => {
      hasher(password).hash(function (error, hash) {
        if (error) reject(error)
        resolve(hash)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js